export const CREATE_ACTIONS = {
    CATALOG: "CATALOG",
    BULK: "BULK",
    SINGLE: "SINGLE"
}
export const ADD_CATALOG_TEXTS = {
    type: "CATALOG",
    title: "Katalogdan Ürün Ekle",
    description: "<span style='font-weight:bold'>n11 kataloğunda olan</span> ürünleri mağazanıza ekleyin.",
    icon: "create-catalog@2x.svg",
    buttonText: "Katalogdan Ürün Ekle",
    info: ""
};
export const ADD_SINGLE_TEXTS = {
    type: "SINGLE",
    title: "Tekil Ürün Ekle",
    description: "<span style='font-weight:bold'>n11 kataloğunda olmayan</span> ürünlerinizi mağazanıza ekleyin.",
    icon: "create-single@2x.svg",
    buttonText: "Tekil Ürün Ekle",
    info: ""
};
export const ADD_BULK_TEXTS = {
    type: "BULK",
    title: 'Toplu Ürün Ekle',
    description: "Ürünlerinizi Excel ile toplu olarak mağazanıza ekleyin.",
    icon: "create-bulk@2x.svg",
    buttonText: "Toplu Ürün Ekle",
    info: "Dosya <span>.xlsx formatında</span> ve <span>en fazla 15 MB</span> boyutunda olmalıdır."
};
